export const navigateTo = (url) => window.location.assign(url);

export const navigateHref = (url) => {
  window.location.href = url;
};
